// extracted by mini-css-extract-plugin
export default {"container":"NoTerritories_container__Ut4Vp","icon":"NoTerritories_icon__8G54h","title":"NoTerritories_title__bHefb","description":"NoTerritories_description__TcVeC"};